let primaryColor = "#318EB8";
let secondaryColor = "#0075A8";
let tercaryColor = "#004D71";

let gradientColorPrimary = "#6C207E";
let gradientColorSecondary = "#6C207E";
let hoverBackgroundColor = "#fff";
let hoverColor = "#6C207E";
let bodyColor = "#5A5A5A";
let bodyAltColor = "#0075A8";
let footerBackgroundColor = "#fff";
let footerLinkColor = tercaryColor;
let footerColor = primaryColor;
let headerBgColor = "#F9F9F9";
let buttonBgColor = bodyColor;

switch (process.env.REACT_APP_SITE) {
  case "neonat":
    primaryColor = "#da6078";
    secondaryColor = "#682d37";
    bodyAltColor = secondaryColor;
    tercaryColor = "#682d37";
    headerBgColor = null;
    buttonBgColor = primaryColor;
    footerLinkColor = primaryColor;
    footerColor = primaryColor;
    break;
  case "transplant":
    // primaryColor = "#004a71";
    // secondaryColor = "#e77d3e";
    primaryColor = "#004a71";
    secondaryColor = "#e77d3e";
    bodyAltColor = primaryColor;
    tercaryColor = "#002f4b";
    headerBgColor = null;
    buttonBgColor = secondaryColor;
    footerLinkColor = primaryColor;
    footerColor = primaryColor;
    break;
  default:
}

export {
  primaryColor,
  secondaryColor,
  tercaryColor,
  gradientColorPrimary,
  gradientColorSecondary,
  hoverBackgroundColor,
  hoverColor,
  bodyColor,
  bodyAltColor,
  footerBackgroundColor,
  footerLinkColor,
  footerColor,
  headerBgColor,
  buttonBgColor,
};



// WEBPACK FOOTER //
// ./src/helpers/colors.js